import React from "react"
import propTypes from "prop-types"

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

const ItemListRow = ({ item, displayName }) => {
  const styleCenterTable = { textAlign: "center", verticalAlign: "middle" }
  const styleLeftTable = { textAlign: "left", verticalAlign: "middle" }
  const cleanMessage = (() => {
    const message = String(item?.message ?? "")

    if (!displayName) {
      return message
    }

    const sanitized = message.replace(new RegExp(`-\\s*${escapeRegExp(displayName)}\\s*-`, "gi"), "")
    return sanitized.replace(/\s{2,}/g, " ").replace(/\s+-\s+/g, " - ").trim()
  })()

  return (
    <tr key={item.id} className="table-light">
      <th style={styleCenterTable} scope="row">{item.row}</th>
      <td style={styleLeftTable}>
        <span>{displayName || "-"}</span>
      </td>
      <td style={styleLeftTable}>
        <span>{cleanMessage}</span>
      </td>
    </tr>
  )
}

ItemListRow.propTypes = {
  item: propTypes.object,
  displayName: propTypes.string,
}

export default ItemListRow
